"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var ButtonGroup_1 = __importDefault(require("@mui/material/ButtonGroup"));
var condo_brain_1 = require("condo-brain");
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var List_1 = __importDefault(require("@mui/material/List"));
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Switch_1 = __importDefault(require("@mui/material/Switch"));
var FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
var ListItemSecondaryAction_1 = __importDefault(require("@mui/material/ListItemSecondaryAction"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
function UserLI(prop) {
    var user = prop.user, editUser = prop.editUser;
    var vacState = user.vaccinated ? '💉' : '🦠';
    var primary = "".concat(vacState, " ").concat(user.name);
    return (react_1.default.createElement(ListItem_1.default, { disabled: !user.active },
        react_1.default.createElement(ListItemText_1.default, { primary: primary, secondary: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Typography_1.default, { component: "span", variant: "body2", style: { display: 'inline' }, color: "textPrimary" }, "".concat(user.unit),
                    '  '),
                react_1.default.createElement(Typography_1.default, { component: "span", variant: "body2", style: { display: 'inline' }, color: "textPrimary" },
                    ",",
                    '  ', "".concat(user.email)),
                user.active && (react_1.default.createElement(Typography_1.default, { component: "span", variant: "body2", style: { display: 'inline' }, color: "textPrimary" },
                    ",",
                    '  ',
                    "Active")),
                !user.active && (react_1.default.createElement(Typography_1.default, { component: "span", variant: "body2", style: { display: 'inline' }, color: "textPrimary" },
                    ",",
                    '  ',
                    "Inactive")),
                !user.admin && user.parkingAdmin && (react_1.default.createElement(Typography_1.default, { component: "span", variant: "body2", style: { display: 'inline' }, color: "textPrimary" },
                    ",",
                    '  ',
                    "Parking Administrator",
                    '  ')),
                user.admin && (react_1.default.createElement(Typography_1.default, { component: "span", variant: "body2", style: { display: 'inline' }, color: "textPrimary" },
                    ",",
                    '  ',
                    "Administrator",
                    '  ')))) }),
        react_1.default.createElement(ListItemSecondaryAction_1.default, null,
            react_1.default.createElement(IconButton_1.default, { edge: "end", "aria-label": "edit", onClick: function () { editUser(user); }, size: "large" },
                react_1.default.createElement(Edit_1.default, null)))));
}
var ListOfUsers = react_1.default.memo(function (prop) {
    var usersLI = prop.localUsers.map(function (user) { return (react_1.default.createElement(UserLI, { key: user.id, user: user, editUser: prop.editUser })); });
    return (react_1.default.createElement(List_1.default, null, usersLI));
});
var useStyles = (0, makeStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    title: {
        margin: theme.spacing(4, 0, 2),
    },
    unselected: {
        backgroundColor: 'grey',
    },
    selected: {
        backgroundColor: '#f37f30',
    },
}); });
var emptyUser = {
    name: '',
    email: '',
    admin: false,
    active: false,
    vaccinated: false,
    parkingAdmin: false,
    type: condo_brain_1.UserType.None,
};
function UserAdmin() {
    var _this = this;
    var classes = useStyles();
    var _a = (0, react_1.useState)([]), users = _a[0], setUsers = _a[1];
    var _b = (0, react_1.useState)(undefined), selectedFiles = _b[0], setSelectedFiles = _b[1];
    var _c = (0, react_1.useState)(undefined), currentFile = _c[0], setCurrentFile = _c[1];
    var _d = (0, react_1.useState)(emptyUser), selectedUser = _d[0], setSelectedUser = _d[1];
    var _e = (0, react_1.useState)(false), userOpen = _e[0], setUserOpen = _e[1];
    var _f = (0, react_1.useState)(selectedUser.name), name = _f[0], setName = _f[1];
    var _g = (0, react_1.useState)(selectedUser.unit), unit = _g[0], setUnit = _g[1];
    var _h = (0, react_1.useState)(selectedUser.email), email = _h[0], setEmail = _h[1];
    var _j = (0, react_1.useState)(selectedUser.phone), phone = _j[0], setPhone = _j[1];
    var _k = (0, react_1.useState)(selectedUser.admin), userAdmin = _k[0], setUserAdmin = _k[1];
    var _l = (0, react_1.useState)(selectedUser.type), userType = _l[0], setUserType = _l[1];
    var _m = (0, react_1.useState)(selectedUser.parkingAdmin), userParkingAdmin = _m[0], setUserParkingAdmin = _m[1];
    var _o = (0, react_1.useState)(selectedUser.active), userActive = _o[0], setUserActive = _o[1];
    var _p = (0, react_1.useState)(react_1.default.createElement("span", null)), userList = _p[0], setUserList = _p[1];
    var _q = (0, react_1.useState)(true), hideInactive = _q[0], setHideInactive = _q[1];
    var _r = (0, react_1.useState)(undefined), selectedUserId = _r[0], setSelectedUserId = _r[1];
    var _s = (0, react_1.useState)(false), userVaccinated = _s[0], setUserVaccinated = _s[1];
    var admin = new condo_brain_1.AdminManager();
    if (!admin) {
        return (react_1.default.createElement("div", null));
    }
    var fetchUsers = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            admin.getUsers().then(function (response) {
                setUsers(response);
            });
            return [2 /*return*/];
        });
    }); };
    var handleChange = function (selectorFiles) {
        if (selectorFiles) {
            setSelectedFiles(selectorFiles);
            setCurrentFile(selectorFiles[0]);
        }
    };
    var handleNameChange = function (event) {
        setName(event.target.value);
    };
    var handleUnitChange = function (event) {
        setUnit(Number(event.target.value));
    };
    var handleEmailChange = function (event) {
        setEmail(event.target.value);
    };
    var handlePhoneChange = function (event) {
        setPhone(event.target.value);
    };
    var handleAdminChange = function (event) {
        setUserAdmin(event.target.checked);
    };
    var handleParkingAdminChange = function (event) {
        setUserParkingAdmin(event.target.checked);
    };
    var handleActiveChange = function (event) {
        setUserActive(event.target.checked);
    };
    var handleVaccineChange = function (event) {
        setUserVaccinated(event.target.checked);
    };
    var handleHideInactive = function (event) {
        setHideInactive(event.target.checked);
    };
    function addUser(e) {
        e.preventDefault();
        var formData = new FormData();
        formData.append('user[name]', name || '');
        formData.append('user[email]', email || '');
        formData.append('user[phone]', phone || '');
        formData.append('user[unit]', String(unit));
        formData.append('user[admin]', String(userAdmin));
        formData.append('user[parking_admin]', String(userParkingAdmin));
        formData.append('user[vaccinated]', String(userVaccinated));
        formData.append('user[active]', String(userActive));
        formData.append('user[resident_type]', String(userType));
        admin.createUser(formData)
            .then(function (_response) {
            fetchUsers();
            setUserOpen(false);
        });
    }
    var editUser = function (user) {
        setSelectedUser(user);
        setSelectedUserId(user.id);
        setName(user.name);
        setUnit(user.unit);
        setEmail(user.email);
        setPhone(user.phone);
        setUserActive(user.active);
        setUserAdmin(user.admin);
        setUserVaccinated(user.vaccinated);
        if (user.parkingAdmin) {
            setUserParkingAdmin(user.parkingAdmin);
        }
        else {
            setUserParkingAdmin(false);
        }
        setUserOpen(true);
        setUserType(user.type);
    };
    function updateUser(e) {
        if (!selectedUserId) {
            addUser(e);
            setUserOpen(false);
        }
        else {
            e.preventDefault();
            var formData = new FormData();
            formData.append('user[user_id]', String(selectedUserId));
            formData.append('user[name]', name || '');
            formData.append('user[email]', email || '');
            formData.append('user[phone]', phone || '');
            formData.append('user[unit]', String(unit));
            formData.append('user[admin]', String(userAdmin));
            formData.append('user[parking_admin]', String(userParkingAdmin));
            formData.append('user[active]', String(userActive));
            formData.append('user[resident_type]', String(userType));
            formData.append('user[vaccinated]', String(userVaccinated));
            admin.editUser(formData, Number(selectedUserId))
                .then(function (_response) {
                fetchUsers();
                setUserOpen(false);
            });
        }
    }
    function upload(e) {
        e.preventDefault();
        if (selectedFiles && selectedFiles[0]) {
            var formData = new FormData();
            formData.append('file', selectedFiles[0]);
            admin.upload(formData)
                .then(function (_response) {
                setCurrentFile(undefined);
                fetchUsers();
            })
                .catch(function () {
                setCurrentFile(undefined);
            });
        }
    }
    var userPopup = (react_1.default.createElement("form", { className: classes.root, noValidate: true, autoComplete: "off", onSubmit: addUser },
        react_1.default.createElement(Dialog_1.default, { open: userOpen, "aria-labelledby": "form-dialog-title", fullWidth: true },
            name && (react_1.default.createElement(DialogTitle_1.default, { id: "form-dialog-title" },
                "Edit",
                ' ',
                selectedUser.name)),
            !name && (react_1.default.createElement(DialogTitle_1.default, { id: "form-dialog-title" }, "Edit User")),
            react_1.default.createElement(DialogContent_1.default, null,
                react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(TextField_1.default, { id: "standard-multiline-flexible", label: "Name", multiline: true, maxRows: 1, value: name, onChange: handleNameChange, style: { width: '100%' } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(TextField_1.default, { id: "standard-multiline-flexible", label: "Unit", multiline: true, maxRows: 1, value: unit, onChange: handleUnitChange, style: { width: '100%' } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(TextField_1.default, { id: "standard-multiline-flexible", label: "Email", multiline: true, maxRows: 1, value: email, onChange: handleEmailChange, style: { width: '100%' } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(TextField_1.default, { id: "standard-multiline-flexible", label: "Phone Number", multiline: true, maxRows: 1, value: phone, onChange: handlePhoneChange, style: { width: '100%' } })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(ButtonGroup_1.default, { disableElevation: true, variant: "contained", color: "primary", "aria-label": "contained primary button group" },
                            react_1.default.createElement(Button_1.default, { onClick: function () { return setUserType(condo_brain_1.UserType.Owner); }, className: userType === condo_brain_1.UserType.Owner ? classes.selected : classes.unselected }, "Owner"),
                            react_1.default.createElement(Button_1.default, { onClick: function () { return setUserType(condo_brain_1.UserType.Tenant); }, className: userType === condo_brain_1.UserType.Tenant ? classes.selected : classes.unselected }, "Tenant"),
                            react_1.default.createElement(Button_1.default, { onClick: function () { return setUserType(condo_brain_1.UserType.None); }, className: (!userType || userType === condo_brain_1.UserType.None) ? classes.selected : classes.unselected }, "None"))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Switch_1.default, { checked: userAdmin, onChange: handleAdminChange, name: "administrator", color: "primary" })), label: "Administrator" })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Switch_1.default, { checked: userParkingAdmin, onChange: handleParkingAdminChange, name: "parkingAdmin", color: "primary" })), label: "Parking Administrator" })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Switch_1.default, { checked: userActive, onChange: handleActiveChange, name: "active", color: "primary" })), label: "Active" })),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                        react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Switch_1.default, { checked: userVaccinated, onChange: handleVaccineChange, name: "vaccinated", color: "primary" })), label: "\uD83D\uDC89 Vaccinated" })))),
            react_1.default.createElement(DialogActions_1.default, null,
                react_1.default.createElement(Button_1.default, { onClick: function () { return setUserOpen(false); }, color: "secondary" }, "Cancel"),
                react_1.default.createElement(Button_1.default, { onClick: function (e) { return updateUser(e); }, color: "primary" }, "Save")))));
    (0, react_1.useEffect)(function () {
        fetchUsers();
    }, [users.length]);
    (0, react_1.useEffect)(function () {
        var showUsers = users;
        if (hideInactive) {
            showUsers = showUsers.filter(function (user) { return user.active; });
        }
        setUserList(react_1.default.createElement(ListOfUsers, { localUsers: showUsers, editUser: editUser }));
    }, [users, hideInactive]);
    return (react_1.default.createElement("div", { className: "section flex-grow" },
        react_1.default.createElement("h4", { className: "center" }, "Resident Admin"),
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 1 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 8 },
                react_1.default.createElement(Button_1.default, { sx: {
                        backgroundColor: '#f37f30',
                        color: 'white',
                        marginBottom: '20px',
                    }, variant: "contained", component: "span", onClick: function () { return editUser(emptyUser); } }, "Add Resident")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 4 },
                react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Switch_1.default, { checked: hideInactive, onChange: handleHideInactive, name: "active", color: "primary" })), label: "Hide Inactive Residents" })),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                userList,
                userPopup,
                react_1.default.createElement("form", { encType: "multipart/form-data", className: classes.root, noValidate: true, autoComplete: "off", onSubmit: upload },
                    react_1.default.createElement("label", { htmlFor: "upload-users" },
                        react_1.default.createElement("input", { style: { display: 'none' }, id: "upload-users", name: "upload-users", type: "file", onChange: function (e) { return handleChange(e.target.files); } }),
                        !currentFile && (react_1.default.createElement("div", null,
                            react_1.default.createElement(Button_1.default, { sx: {
                                    backgroundColor: '#f37f30',
                                    color: 'white',
                                    marginBottom: '20px',
                                }, variant: "contained", component: "span" }, "Choose JSON file"),
                            ' ')),
                        currentFile && (react_1.default.createElement(Button_1.default, { sx: {
                                backgroundColor: '#f37f30',
                                color: 'white',
                                marginBottom: '20px',
                            }, variant: "contained", type: "submit" },
                            "Upload",
                            '  ',
                            currentFile.name))))))));
}
exports.default = UserAdmin;
